'use client'

import ReactMarkdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { cn } from '@/lib/tailwind'

interface MarkdownContentProps {
  children: string
  className?: string
}

function getHostname(href: string): string {
  try {
    return new URL(href).hostname.replace(/^www\./, '')
  } catch {
    return href
  }
}

const components: Components = {
  p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
  a: ({ href, children }) => {
    const childText = String(children)
    const isAutolinked = href === childText
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-brand-link decoration-brand-link-muted hover:decoration-brand-link underline underline-offset-2"
      >
        {isAutolinked ? getHostname(href!) : children}
      </a>
    )
  },
  h1: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  h2: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  h3: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  h4: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  h5: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  h6: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  img: () => null,
  hr: () => null,
  pre: ({ children }) => <>{children}</>,
  code: ({ children }) => <>{children}</>,
}

export function MarkdownContent({ children, className }: MarkdownContentProps) {
  return (
    <div className={cn(className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        components={components}
      >
        {children}
      </ReactMarkdown>
    </div>
  )
}
